import { useEffect, useState } from "react";

export function useLocalStorageState(key, defaultValue, options = {}) {
  const { parse = JSON.parse, stringify = JSON.stringify } = options;

  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved !== null ? parse(saved) : defaultValue;
    } catch (error) {
      console.error(`Failed to read localStorage key "${key}"`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, stringify(value));
    } catch (error) {
      console.error(`Failed to save localStorage key "${key}"`, error);
    }
  }, [key, value, stringify]);

  return [value, setValue];
}